"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const ChargeFilterValidator_1 = __importDefault(require("./ChargeFilterValidator"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class PaginatedChargeFilterValidator extends GenericValidator_1.default {
    constructor(chargeFilterValidator) {
        super();
        this._chargeFilterValidator =
            chargeFilterValidator ?? new ChargeFilterValidator_1.default();
    }
    _chargeFilterValidator;
    schema = joi_1.default.object({
        filter: joi_1.default.object().optional(),
        pageSize: joi_1.default.number().optional(),
        pageNumber: joi_1.default.number().optional(),
        sort: joi_1.default.object({
            field: joi_1.default.string().optional(),
            order: joi_1.default.string().valid('asc', 'desc').required(),
        }).optional(),
    });
    validate(input) {
        super.validate(input, 'IPaginatedChargeFilter', this.schema);
        const issues = [];
        const filter = input.filter;
        if (filter) {
            try {
                this._chargeFilterValidator.validate(filter);
            }
            catch (error) {
                if (error instanceof errors_1.ValidationError) {
                    issues.push(...error.validationIssues);
                }
                else {
                    issues.push(new errors_1.Errors.ValidationIssue('IPaginatedChargeFilter', errors_1.Errors.ValidationErrorCode.invalidValue, 'filter', filter));
                }
            }
        }
        if (issues.length > 0) {
            const paginatedChargeFilterError = new errors_1.Errors.ValidationError();
            issues.forEach((issue) => {
                paginatedChargeFilterError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
            });
            throw paginatedChargeFilterError;
        }
    }
}
exports.default = PaginatedChargeFilterValidator;
